export default "assets/images/icons/marker-76604a83.svg";